(function () {

    'use strict';

    angular.module('asys')
        .controller('AsysController', AsysController);

    AsysController.$inject = [
        '$rootScope',
        '$log'
    ];
    function AsysController($rootScope, $log) {
        var vm = this;

        $rootScope.tracking = [];

        $log.debug('AsysController', vm);
    }
})();
